<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add a Potential Syngergy:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    
                     

                      <v-textarea 
                    outline 
                    :label="synergytitleLabeltext" 
                    v-model="synergytitle" 
                    :hint="synergytitleHint" 
                    :rules="textInputRules"></v-textarea> 

                    <v-select
                        v-model="segment1"
                        :items="bmcsegments"
                        :label="segment1LabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>

                    <v-select
                        v-model="segment2"
                        :items="bmcsegments"
                        :label="segment2LabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>

                    <v-textarea 
                    outline 
                    :label="synergydetailsLabeltext" 
                    v-model="synergydetails" 
                    :hint="synergydetailsHint" 
                    :rules="textInputRules"></v-textarea>

                    <v-textarea 
                    outline 
                    :label="synergyvalueLabeltext" 
                    v-model="synergyvalue" 
                    :hint="synergyvalueHint" 
                    :rules="textInputRules"></v-textarea>



                    <!-- <v-select
                        v-model="aasofferingpercentagebenefitdefault"
                        :items="aasofferingpercentagebenefitrange"
                        :label="aasofferingpercentagebenefitLabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select> -->

                    <!-- <v-checkbox v-model="featureavailableinacompetingproduct" :label="featureavailableinacompetingproductLabeltext"></v-checkbox>  -->

                                        <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Detail</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Synergy</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            synergytitle: '',
            synergytitleLabeltext: 'What would you like to call this synergy?',
            synergytitleHint: 'A title can help hint at what this value this synergy can provide to the business.',
            synergydetails: '',
            synergydetailsLabeltext: 'Please provide a detailed description of the synergy.',
            synergydetailsHint: 'If any additional notes needs to be included, please add it in this section.',
            synergyvalue: '', 
            synergyvalueLabeltext: 'What value does this synergy provide to the business?',
            synergyvalueHint: 'Enter the value or benefit to the business, which can result from a amulgumation of the two business components.',
            

            segment1LabelText: '',
            segment2LabelText: '',

            segment1: 'Value Proposition',
            segment2: 'Value Proposition',
            bmcsegments: ['Value Proposition', 'Customer segment', 'Revenue stream', 'Distribution channel', 'Customer relationship', 'Key activity', 'Key resource', 'Key partner', 'Cost structure'],
             
           
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const porentialsynergy = {
                synergytitle: this.synergytitle,
                segment1: this.segment1,
                segment2: this.segment2,
                synergydetails: this.synergydetails,
                synergyvalue: this.synergyvalue
                
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('potentialsynergies');

        dbref.add(porentialsynergy).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('synergyadded')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
